import React from 'react';
import { IconText } from '@homeexchange/design';
import i18n from '../../i18n';
var REACTIVITY_LEVEL_MAPPING = {
    low: {
        icon: 'low-reactivity',
        color: 'tertiary-600',
        shortLabel: i18n.t('user:global.low.responseRate.short'),
        longLabel: i18n.t('user:global.low.responseRate.long')
    },
    average: {
        icon: 'average-reactivity',
        color: 'neutral-600',
        shortLabel: i18n.t('user:global.average.responseRate.short'),
        longLabel: i18n.t('user:global.average.responseRate.long')
    },
    great: {
        icon: 'great-reactivity',
        color: 'secondary-500',
        shortLabel: i18n.t('user:global.good.responseRate.short'),
        longLabel: i18n.t('user:global.good.responseRate.long')
    },
    excellent: {
        icon: 'excellent-reactivity',
        color: 'secondary-700',
        shortLabel: i18n.t('user:global.excellent.responseRate.short'),
        longLabel: i18n.t('user:global.excellent.responseRate.long')
    }
};
export var ReactivityLevel = function (_a) {
    var reactivityLevel = _a.reactivityLevel, displayLongLabel = _a.displayLongLabel, textSize = _a.textSize;
    var _b = REACTIVITY_LEVEL_MAPPING[reactivityLevel.toLowerCase()], icon = _b.icon, color = _b.color, shortLabel = _b.shortLabel, longLabel = _b.longLabel;
    return (React.createElement(IconText, { icon: icon, color: color, text: displayLongLabel ? longLabel : shortLabel, iconSize: "2xl", textSize: textSize }));
};
